import React from 'react'
// import { Layout, Button } from 'antd'
import { Layout } from 'antd'
import { FormattedMessage } from 'react-intl'
import { Link, withRouter } from 'react-router-dom'
import LanguageSelector from '../../components/LayoutComponents/TopBar/LanguageSelector'
import styles from './style.module.scss'

@withRouter
class LoginLayout extends React.PureComponent {
  state = {
    backgroundNumber: 1,
    backgroundEnabled: false,
  }

  changeBackground = () => {
    const { backgroundNumber } = this.state
    this.setState({
      backgroundEnabled: true,
      backgroundNumber: backgroundNumber === 5 ? 1 : backgroundNumber + 1,
    })
  }

  toggleBackground = () => {
    const { backgroundEnabled } = this.state
    this.setState({
      backgroundEnabled: !backgroundEnabled,
    })
  }

  render() {
    const { children } = this.props
    const { backgroundNumber, backgroundEnabled } = this.state

    return (
      <Layout>
        <Layout.Content>
          <div
            className={backgroundEnabled ? `${styles.layout} ${styles.light}` : `${styles.layout}`}
            style={{
              backgroundImage: backgroundEnabled
                ? `url('/resources/images/photos/${backgroundNumber}.jpeg')`
                : `none`,
            }}
          >
            <div className={styles.header}>
              <div className={styles.logo}>
                <Link to="/">
                  {!backgroundEnabled && <img src="/resources/images/logo.png" alt="Plain4" />}
                  {backgroundEnabled && (
                    <img src="/resources/images/logo-inverse.png" alt="Plain4" />
                  )}
                </Link>
              </div>
              <div className={styles.controls}>
                {/* <div className="d-inline-block mr-3">
                  <Button type="default" onClick={this.changeBackground}>
                    Change Background
                  </Button>
                </div>
                <div className="d-inline-block">
                  <Button type="default" onClick={this.toggleBackground}>
                    Toggle Background
                  </Button>
                </div> */}
                <div className="d-inline-block mr-3">
                  <FormattedMessage id="language" />:
                  <LanguageSelector />
                </div>
              </div>
              <nav className={styles.navigation}>
                <ul className={styles.navigationItems}>
                  <li>
                    <a href="javascript: void(0);">
                      &larr; <FormattedMessage id="user.login.top.back" />
                    </a>
                  </li>
                  <li>
                    <a className={styles.navigationActive} href="javascript: void(0);">
                      <FormattedMessage id="user.login.top.login" />
                    </a>
                  </li>
                  <li>
                    <a href="javascript: void(0);">
                      <FormattedMessage id="user.login.top.about" />
                    </a>
                  </li>
                  <li>
                    <a href="javascript: void(0);">
                      <FormattedMessage id="user.login.top.support" />
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className={styles.content}>{children}</div>
            <div className={`${styles.footer} text-center`}>
              <ul className="list-unstyled list-inline mb-3">
                <li className="list-inline-item">
                  <a href="javascript: void(0);">
                    <FormattedMessage id="footer.termsOfUse" />
                  </a>
                </li>
                <li className="active list-inline-item">
                  <a href="javascript: void(0);">
                    <FormattedMessage id="footer.compliance" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="javascript: void(0);">
                    <FormattedMessage id="footer.confidential" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="javascript: void(0);">
                    <FormattedMessage id="footer.support" />
                  </a>
                </li>
                <li className="list-inline-item">
                  <a href="javascript: void(0);">
                    <FormattedMessage id="footer.contacts" />
                  </a>
                </li>
              </ul>
              <p>
                &copy; <FormattedMessage id="copyright" />
              </p>
            </div>
          </div>
        </Layout.Content>
      </Layout>
    )
  }
}

export default LoginLayout
